// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  width: 85%;
  padding-bottom: 1.5rem;
  margin: auto;
  overflow: visible !important;
  min-height: fit-content;
  display: flex;
  flex-direction: column;
  /* Monthly Summary Section */
  /* Show summary only when there's enough space */
  /* Also hide on very small screens where calendar takes most space */
}
.calendar-container .day.empty {
  visibility: hidden;
}
.calendar-container .day.other-month {
  opacity: 0.3;
  pointer-events: none;
}
.calendar-container .calendar-header {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 10;
}
.calendar-container .calendar-header select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  position: relative;
  z-index: 11;
  pointer-events: auto;
  color: #374151;
}
.calendar-container .calendar-header select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  z-index: 12;
}
.calendar-container .calendar-header select option {
  background: #fff;
  color: #374151;
  padding: 4px 8px;
}
.calendar-container .calendar-grid {
  display: grid;
  overflow: visible;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  flex: 1 1;
}
.calendar-container .calendar-grid .weekday {
  text-align: center;
  font-weight: 600;
  color: #6b7280;
  padding: 8px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.calendar-container .calendar-grid .day {
  min-height: 40px;
  padding: 6px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  position: relative;
  cursor: pointer;
  overflow: visible;
  transition: all 0.2s ease;
}
.calendar-container .calendar-grid .day:hover {
  z-index: 10000;
}
.calendar-container .calendar-grid .day.empty {
  display: none;
}
.calendar-container .calendar-grid .day.today {
  background: #dbeafe;
  border-color: #3b82f6;
}
.calendar-container .calendar-grid .day.today .day-number {
  font-weight: 700;
  color: #1d4ed8;
}
.calendar-container .calendar-grid .day.has-events {
  background: #f0f9ff;
  border: 2px solid #0ea5e9;
}
.calendar-container .calendar-grid .day.has-events .event-count {
  color: #0284c7;
}
.calendar-container .calendar-grid .day.empty {
  background: transparent;
  border: none;
  cursor: default;
}
.calendar-container .calendar-grid .day:hover:not(.empty) {
  transform: translateY(-1px);
  background: #ffffff;
  border-color: #94a3b8;
}
.calendar-container .calendar-grid .day.selected-date {
  background: #eff6ff;
  border: 2.5px solid #3b82f6;
  transform: scale(1.02);
  z-index: 20;
}
.calendar-container .calendar-grid .day.selected-date .day-number {
  color: #1e40af;
  font-weight: 700;
}
.calendar-container .calendar-grid .day.selected-date .event-count {
  background-color: #3b82f6;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 10px;
}
.calendar-container .calendar-grid .day.selected-date:hover {
  background: #dbeafe;
  border-color: #2563eb;
  border-width: 3px;
  transform: scale(1.02);
}
.calendar-container .calendar-grid .day.selected-date.today {
  background: #dbeafe;
  border: 2.5px solid #2563eb;
  position: relative;
}
.calendar-container .calendar-grid .day.selected-date.today::after {
  content: "";
  position: absolute;
  top: 4px;
  right: 4px;
  width: 5px;
  height: 5px;
  background: #fbbf24;
  border-radius: 50%;
}
.calendar-container .calendar-grid .day.selected-date.today .day-number {
  color: #1e3a8a;
  font-weight: 800;
}
.calendar-container .calendar-grid .day.selected-date.has-events {
  background: #f0f9ff;
  border: 2.5px solid #0284c7;
}
.calendar-container .calendar-grid .day.selected-date.has-events .event-count {
  background-color: #0284c7;
  color: white;
}
.calendar-container .calendar-grid .day.selected-date.has-events:hover {
  background: #e0f2fe;
  border-color: #0369a1;
  border-width: 3px;
}
.calendar-container .calendar-grid .day .day-number {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}
.calendar-container .calendar-grid .day .event-count {
  font-size: 10px;
  color: #0ea5e9;
  margin-top: 2px;
  font-weight: 600;
}
.calendar-container .calendar-grid .day .tooltip {
  position: absolute !important;
  background: white;
  z-index: 99999 !important;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.08);
  min-width: 300px;
  max-width: 380px;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.98);
  max-height: 210px;
  display: flex;
  flex-direction: column;
  /* Tab Navigation */
  /* Content Area */
  /* Bottom positioning arrow */
  /* Top positioning arrow */
  /* Right positioning arrow */
  /* Left positioning arrow */
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom, .calendar-container .calendar-grid .day .tooltip.tooltip-left, .calendar-container .calendar-grid .day .tooltip.tooltip-right {
  position: absolute !important;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom {
  top: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top {
  bottom: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right {
  top: 50%;
  left: calc(100% + 3px);
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left {
  top: 50%;
  right: calc(100% + 3px);
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip .tooltip::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-bottom::before {
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-top::before {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-left::before {
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  border-left-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-right::before {
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  border-right-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 12px 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab .tab-icon {
  font-size: 0.875rem;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:first-child {
  border-radius: 12px 0 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:last-child {
  border-radius: 0 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab.active {
  background: #fff;
  color: #374151;
  border-bottom: 2px solid #3b82f6;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:hover:not(.active) {
  background: #f1f5f9;
  color: #374151;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-content {
  padding: 16px;
  flex: 1 1;
  overflow-y: auto;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-title .section-icon {
  font-size: 1rem;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable {
  max-height: 200px;
  /* Limit height for scrolling */
  padding-right: 4px;
  /* Custom scrollbar */
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar {
  width: 4px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item {
  padding: 10px 12px;
  border-radius: 8px;
  background: #eef2ff;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable {
  cursor: pointer;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable:hover {
  background: #d8e3f7;
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable.task-item {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable.task-item:hover {
  background: #d1fae5;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .court-ref,
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .task-name {
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .item-badge {
  font-size: 0.625rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  background: #dbeafe;
  color: #1e40af;
  white-space: nowrap;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .item-badge.task-badge {
  background: #fef3c7;
  color: #92400e;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-details {
  font-size: 0.6875rem;
  color: #6b7280;
  line-height: 1.4;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-more {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 6px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-more .more-icon {
  font-weight: 700;
  color: #3b82f6;
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn {
  padding: 12px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #fff;
  border: none;
  border-radius: 0 0 12px 12px;
  font-size: 0.75rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-top: 1px solid #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn:active {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
}
.calendar-container .calendar-grid .day .tooltip::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom-left::before, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom-right::before {
  top: -12px;
  border-bottom-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-left::before {
  left: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-right::before {
  right: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-top-left::before, .calendar-container .calendar-grid .day .tooltip.tooltip-top-right::before {
  bottom: -12px;
  border-top-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-left::before {
  left: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-right::before {
  right: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-right-top::before, .calendar-container .calendar-grid .day .tooltip.tooltip-right-bottom::before {
  left: -12px;
  border-right-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-center::before {
  top: 50%;
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-top::before {
  top: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-bottom::before {
  bottom: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-left-top::before, .calendar-container .calendar-grid .day .tooltip.tooltip-left-bottom::before {
  right: -12px;
  border-left-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-center::before {
  top: 50%;
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-top::before {
  top: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-bottom::before {
  bottom: 20px;
}
.calendar-container .monthly-summary {
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--grey-lightest-shade);
  border: 1px solid var(--grey-shade-one);
  border-radius: var(--border-radius-primary);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  /* Responsive adjustments for summary */
}
.calendar-container .monthly-summary .summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--grey-shade-one);
}
.calendar-container .monthly-summary .summary-header h4 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.calendar-container .monthly-summary .summary-header h4::before {
  content: "";
  width: 6px;
  height: 6px;
  background: var(--primary-light-color);
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(58, 134, 255, 0.4);
}
.calendar-container .monthly-summary .summary-stats {
  display: flex;
  gap: 1rem;
}
.calendar-container .monthly-summary .summary-stats .stat-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: var(--border-radius-primary);
  transition: all 0.2s ease;
  cursor: default;
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat {
  background: var(--primary-light-bg);
  border: 1px solid rgba(0, 74, 154, 0.2);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat:hover {
  background: rgba(238, 242, 255, 0.8);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 74, 154, 0.1);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat .stat-content .stat-number {
  color: var(--primary-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat .stat-content .stat-label {
  color: var(--primary-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat {
  background: var(--success-light-bg);
  border: 1px solid rgba(22, 101, 52, 0.2);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat:hover {
  background: var(--success-dark-bg);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(22, 101, 52, 0.1);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat .stat-content .stat-number {
  color: var(--success-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat .stat-content .stat-label {
  color: var(--success-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-icon .icon-image {
  opacity: 0.8;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}
@media (max-width: 768px) {
  .calendar-container .monthly-summary {
    margin-top: 1rem;
    padding: 0.75rem;
  }
  .calendar-container .monthly-summary .summary-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .calendar-container .monthly-summary .summary-header .fallback-note {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
  .calendar-container .monthly-summary .summary-stats {
    flex-direction: column;
    gap: 0.75rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item {
    padding: 0.5rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-icon {
    width: 36px;
    height: 36px;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
    font-size: 1.25rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-label {
    font-size: 0.7rem;
  }
}
@media (max-width: 480px) {
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
    font-size: 1.1rem;
  }
}
@media (max-height: 700px) {
  .calendar-container .monthly-summary {
    display: none;
  }
}
@media (max-width: 480px) and (max-height: 800px) {
  .calendar-container .monthly-summary {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CalendarWidget/CalendarWidget.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EA2mBA,4BAAA;EA0KA,gDAAA;EAOA,oEAAA;AAxxBF;AAFE;EAEE,kBAAA;AAGJ;AAKE;EAEE,YAAA;EACA,oBAAA;AAJJ;AAOE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AALJ;AAOI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AALN;AAOM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;EACA,WAAA;AALR;AAQM;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AANR;AAWE;EACE,aAAA;EACA,iBAAA;EACA,qCAAA;EACA,QAAA;EACA,SAAA;AATJ;AAWI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AATN;AAYI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAVN;AAYM;EACE,cAAA;AAVR;AAaM;EACE,aAAA;AAXR;AAcM;EACE,mBAAA;EACA,qBAAA;AAZR;AAcQ;EACE,gBAAA;EACA,cAAA;AAZV;AAgBM;EACE,mBAAA;EACA,yBAAA;AAdR;AAgBQ;EACE,cAAA;AAdV;AAkBM;EACE,uBAAA;EACA,YAAA;EACA,eAAA;AAhBR;AAmBM;EACE,2BAAA;EAEA,mBAAA;EACA,qBAAA;AAlBR;AAsBM;EACE,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;AApBR;AAsBQ;EACE,cAAA;EACA,gBAAA;AApBV;AAuBQ;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AArBV;AAyBQ;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;AAvBV;AA2BQ;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;AAzBV;AA4BU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA1BZ;AA6BU;EACE,cAAA;EACA,gBAAA;AA3BZ;AAgCQ;EACE,mBAAA;EACA,2BAAA;AA9BV;AAgCU;EACE,yBAAA;EACA,YAAA;AA9BZ;AAiCU;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;AA/BZ;AAoCM;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAlCR;AAqCM;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnCR;AAsCM;EACE,6BAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,0EAAA;EAEA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EAqEA,mBAAA;EAgDA,iBAAA;EAmMA,6BAAA;EAqBA,0BAAA;EAqBA,4BAAA;EAqBA,2BAAA;AAtZR;AAiCQ;EAIE,6BAAA;AAlCV;AAqCQ;EACE,qBAAA;EACA,SAAA;EACA,2BAAA;AAnCV;AAsCQ;EACE,wBAAA;EACA,SAAA;EACA,2BAAA;AApCV;AAuCQ;EACE,QAAA;EACA,sBAAA;EACA,2BAAA;AArCV;AAwCQ;EACE,QAAA;EACA,uBAAA;EACA,2BAAA;AAtCV;AAyCQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AAvCV;AA0CQ;EACE,UAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;AAxCV;AA2CQ;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAzCV;AA4CQ;EACE,YAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;AA1CV;AA6CQ;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AA3CV;AA+CQ;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,4BAAA;AA7CV;AA+CU;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;AA7CZ;AA+CY;EACE,mBAAA;AA7Cd;AAgDY;EACE,yBAAA;AA9Cd;AAiDY;EACE,yBAAA;AA/Cd;AAkDY;EACE,gBAAA;EACA,cAAA;EACA,gCAAA;AAhDd;AAmDY;EACE,mBAAA;EACA,cAAA;AAjDd;AAuDQ;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AArDV;AAyDU;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;AAvDZ;AAyDY;EACE,eAAA;AAvDd;AA2DU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzDZ;AA+DY;EACE,iBAAA;EACA,+BAAA;EAEA,kBAAA;EAEA,qBAAA;AA/Dd;AAgEc;EACE,UAAA;AA9DhB;AAiEc;EACE,mBAAA;EACA,kBAAA;AA/DhB;AAkEc;EACE,mBAAA;EACA,kBAAA;AAhEhB;AAkEgB;EACE,mBAAA;AAhElB;AAsEU;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AApEZ;AAsEY;EACE,eAAA;AApEd;AAsEc;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AApEhB;AAsEc;EACE,mBAAA;EACA,qBAAA;AApEhB;AAsEgB;EACE,mBAAA;EAEA,2BAAA;EACA,8CAAA;AArElB;AA0EY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAxEd;AA0Ec;;EAEE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAxEhB;AA2Ec;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAzEhB;AA2EgB;EACE,mBAAA;EACA,cAAA;AAzElB;AA8EY;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;AA5Ed;AAgFU;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AA9EZ;AAgFY;EACE,gBAAA;EACA,cAAA;AA9Ed;AAmFQ;EACE,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,6BAAA;AAjFV;AAuFU;EACE,6DAAA;AArFZ;AAwFU;EACE,6DAAA;AAtFZ;AA0FQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AAxFV;AA4FQ;EAGE,UAAA;EACA,4BAAA;AA5FV;AA+FQ;EACE,SAAA;EACA,2BAAA;AA7FV;AAgGQ;EACE,UAAA;AA9FV;AAiGQ;EACE,WAAA;AA/FV;AAmGQ;EAGE,aAAA;EACA,yBAAA;AAnGV;AAsGQ;EACE,SAAA;EACA,2BAAA;AApGV;AAuGQ;EACE,UAAA;AArGV;AAwGQ;EACE,WAAA;AAtGV;AA0GQ;EAGE,WAAA;EACA,2BAAA;AA1GV;AA6GQ;EACE,QAAA;EACA,2BAAA;AA3GV;AA8GQ;EACE,SAAA;AA5GV;AA+GQ;EACE,YAAA;AA7GV;AAiHQ;EAGE,YAAA;EACA,0BAAA;AAjHV;AAoHQ;EACE,QAAA;EACA,2BAAA;AAlHV;AAqHQ;EACE,SAAA;AAnHV;AAsHQ;EACE,YAAA;AApHV;AA2HE;EACE,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,uCAAA;EACA,2CAAA;EACA,yCAAA;EAmHA,uCAAA;AA3OJ;AA0HI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAxHN;AA0HM;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAxHR;AA0HQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,2CAAA;AAxHV;AA4HI;EACE,aAAA;EACA,SAAA;AA1HN;AA4HM;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;EACA,eAAA;AA1HR;AA4HQ;EACE,mCAAA;EACA,uCAAA;AA1HV;AA4HU;EACE,oCAAA;EACA,2BAAA;EACA,2CAAA;AA1HZ;AA6HU;EACE,2BAAA;AA3HZ;AA8HU;EACE,2BAAA;AA5HZ;AAgIQ;EACE,mCAAA;EACA,wCAAA;AA9HV;AAgIU;EACE,kCAAA;EACA,2BAAA;EACA,4CAAA;AA9HZ;AAiIU;EACE,2BAAA;AA/HZ;AAkIU;EACE,2BAAA;AAhIZ;AAoIQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAlIV;AAoIU;EACE,YAAA;AAlIZ;AAsIQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AApIV;AAsIU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApIZ;AAuIU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AArIZ;AA4II;EA1HF;IA2HI,gBAAA;IACA,gBAAA;EAzIJ;EA2II;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAzIN;EA2IM;IACE,iBAAA;IACA,sBAAA;EAzIR;EA6II;IACE,sBAAA;IACA,YAAA;EA3IN;EA6IM;IACE,eAAA;EA3IR;EA6IQ;IACE,WAAA;IACA,YAAA;EA3IV;EA8IQ;IACE,kBAAA;EA5IV;EA+IQ;IACE,iBAAA;EA7IV;AACF;AAkJI;EAEI;IACE,iBAAA;EAjJR;AACF;AAuJE;EACE;IACE,aAAA;EArJJ;AACF;AAyJE;EACE;IACE,aAAA;EAvJJ;AACF","sourcesContent":[".calendar-container {\r\n  width: 85%;\r\n  padding-bottom: 1.5rem;\r\n  margin: auto;\r\n  overflow: visible !important;\r\n  min-height: fit-content;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .day.empty {\r\n    // Hide empty cells completely\r\n    visibility: hidden;\r\n\r\n    // Or alternatively, just make them appear empty but maintain grid structure\r\n    // background: transparent;\r\n    // border: none;\r\n    // cursor: default;\r\n  }\r\n\r\n  .day.other-month {\r\n    // Style for days from other months (if any slip through)\r\n    opacity: 0.3;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .calendar-header {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    margin-bottom: 1.5rem;\r\n    position: relative;\r\n    z-index: 10;\r\n\r\n    select {\r\n      padding: 8px 12px;\r\n      border-radius: 8px;\r\n      border: 1px solid #d1d5db;\r\n      font-size: 14px;\r\n      background: #fff;\r\n      cursor: pointer;\r\n      position: relative;\r\n      z-index: 11;\r\n      pointer-events: auto;\r\n      color: #374151;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        z-index: 12;\r\n      }\r\n\r\n      option {\r\n        background: #fff;\r\n        color: #374151;\r\n        padding: 4px 8px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .calendar-grid {\r\n    display: grid;\r\n    overflow: visible;\r\n    grid-template-columns: repeat(7, 1fr);\r\n    gap: 8px;\r\n    flex: 1;\r\n\r\n    .weekday {\r\n      text-align: center;\r\n      font-weight: 600;\r\n      color: #6b7280;\r\n      padding: 8px;\r\n      font-size: 13px;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.5px;\r\n    }\r\n\r\n    .day {\r\n      min-height: 40px;\r\n      padding: 6px;\r\n      border-radius: 8px;\r\n      background: #f9fafb;\r\n      border: 1px solid #e5e7eb;\r\n      position: relative;\r\n      cursor: pointer;\r\n      overflow: visible;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        z-index: 10000;\r\n      }\r\n\r\n      &.empty {\r\n        display: none;\r\n      }\r\n\r\n      &.today {\r\n        background: #dbeafe;\r\n        border-color: #3b82f6;\r\n\r\n        .day-number {\r\n          font-weight: 700;\r\n          color: #1d4ed8;\r\n        }\r\n      }\r\n\r\n      &.has-events {\r\n        background: #f0f9ff;\r\n        border: 2px solid #0ea5e9;\r\n\r\n        .event-count {\r\n          color: #0284c7;\r\n        }\r\n      }\r\n\r\n      &.empty {\r\n        background: transparent;\r\n        border: none;\r\n        cursor: default;\r\n      }\r\n\r\n      &:hover:not(.empty) {\r\n        transform: translateY(-1px);\r\n        // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n        background: #ffffff;\r\n        border-color: #94a3b8;\r\n      }\r\n\r\n      // Selected date styling - UPDATED FOR SUBTLE & APPEALING LOOK\r\n      &.selected-date {\r\n        background: #eff6ff;\r\n        border: 2.5px solid #3b82f6;\r\n        transform: scale(1.02);\r\n        z-index: 20;\r\n\r\n        .day-number {\r\n          color: #1e40af;\r\n          font-weight: 700;\r\n        }\r\n\r\n        .event-count {\r\n          background-color: #3b82f6;\r\n          color: white;\r\n          padding: 2px 6px;\r\n          border-radius: 4px;\r\n          font-weight: 600;\r\n          font-size: 10px;\r\n        }\r\n\r\n        // Override hover state for selected dates\r\n        &:hover {\r\n          background: #dbeafe;\r\n          border-color: #2563eb;\r\n          border-width: 3px;\r\n          transform: scale(1.02);\r\n        }\r\n\r\n        // If selected date is also today\r\n        &.today {\r\n          background: #dbeafe;\r\n          border: 2.5px solid #2563eb;\r\n          position: relative;\r\n          \r\n          // Subtle gold dot indicator in top-right\r\n          &::after {\r\n            content: \"\";\r\n            position: absolute;\r\n            top: 4px;\r\n            right: 4px;\r\n            width: 5px;\r\n            height: 5px;\r\n            background: #fbbf24;\r\n            border-radius: 50%;\r\n          }\r\n          \r\n          .day-number {\r\n            color: #1e3a8a;\r\n            font-weight: 800;\r\n          }\r\n        }\r\n\r\n        // If selected date has events\r\n        &.has-events {\r\n          background: #f0f9ff;\r\n          border: 2.5px solid #0284c7;\r\n          \r\n          .event-count {\r\n            background-color: #0284c7;\r\n            color: white;\r\n          }\r\n\r\n          &:hover {\r\n            background: #e0f2fe;\r\n            border-color: #0369a1;\r\n            border-width: 3px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .day-number {\r\n        font-weight: 500;\r\n        color: #374151;\r\n        font-size: 14px;\r\n      }\r\n\r\n      .event-count {\r\n        font-size: 10px;\r\n        color: #0ea5e9;\r\n        margin-top: 2px;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .tooltip {\r\n        position: absolute !important;\r\n        background: white;\r\n        z-index: 99999 !important;\r\n        border: 1px solid #e2e8f0;\r\n        border-radius: 12px;\r\n        padding: 0;\r\n        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12),\r\n          0 4px 8px rgba(0, 0, 0, 0.08);\r\n        min-width: 300px;\r\n        max-width: 380px;\r\n        backdrop-filter: blur(8px);\r\n        background: rgba(255, 255, 255, 0.98);\r\n        max-height: 210px;\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        &.tooltip-top,\r\n        &.tooltip-bottom,\r\n        &.tooltip-left,\r\n        &.tooltip-right {\r\n          position: absolute !important;\r\n        }\r\n\r\n        &.tooltip-bottom {\r\n          top: calc(100% + 3px);\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n        }\r\n\r\n        &.tooltip-top {\r\n          bottom: calc(100% + 3px);\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n        }\r\n\r\n        &.tooltip-right {\r\n          top: 50%;\r\n          left: calc(100% + 3px);\r\n          transform: translateY(-50%);\r\n        }\r\n\r\n        &.tooltip-left {\r\n          top: 50%;\r\n          right: calc(100% + 3px);\r\n          transform: translateY(-50%);\r\n        }\r\n\r\n        .tooltip::before {\r\n          content: \"\";\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n          border: 6px solid transparent;\r\n        }\r\n\r\n        .tooltip-bottom::before {\r\n          top: -12px;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n          border-bottom-color: #e2e8f0;\r\n        }\r\n\r\n        .tooltip-top::before {\r\n          bottom: -12px;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n          border-top-color: #e2e8f0;\r\n        }\r\n\r\n        .tooltip-left::before {\r\n          right: -12px;\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n          border-left-color: #e2e8f0;\r\n        }\r\n\r\n        .tooltip-right::before {\r\n          left: -12px;\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n          border-right-color: #e2e8f0;\r\n        }\r\n\r\n        /* Tab Navigation */\r\n        .tooltip-tabs {\r\n          display: flex;\r\n          border-bottom: 1px solid #e2e8f0;\r\n          background: #f8fafc;\r\n          border-radius: 12px 12px 0 0;\r\n\r\n          .tab {\r\n            flex: 1;\r\n            padding: 12px 16px;\r\n            border: none;\r\n            background: transparent;\r\n            cursor: pointer;\r\n            font-size: 0.75rem;\r\n            font-weight: 600;\r\n            color: #6b7280;\r\n            transition: all 0.2s ease;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            gap: 6px;\r\n            border-radius: 12px 12px 0 0;\r\n\r\n            .tab-icon {\r\n              font-size: 0.875rem;\r\n            }\r\n\r\n            &:first-child {\r\n              border-radius: 12px 0 0 0;\r\n            }\r\n\r\n            &:last-child {\r\n              border-radius: 0 12px 0 0;\r\n            }\r\n\r\n            &.active {\r\n              background: #fff;\r\n              color: #374151;\r\n              border-bottom: 2px solid #3b82f6;\r\n            }\r\n\r\n            &:hover:not(.active) {\r\n              background: #f1f5f9;\r\n              color: #374151;\r\n            }\r\n          }\r\n        }\r\n\r\n        /* Content Area */\r\n        .tooltip-content {\r\n          padding: 16px;\r\n          flex: 1;\r\n          overflow-y: auto;\r\n        }\r\n\r\n        .tooltip-section {\r\n          .tooltip-title {\r\n            font-size: 0.875rem;\r\n            font-weight: 700;\r\n            margin-bottom: 12px;\r\n            color: #1f2937;\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 6px;\r\n            padding-bottom: 8px;\r\n            border-bottom: 1px solid #f1f5f9;\r\n\r\n            .section-icon {\r\n              font-size: 1rem;\r\n            }\r\n          }\r\n\r\n          .tooltip-items {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n\r\n            // &>*:last-child {\r\n            //   margin-bottom: 8px;\r\n            // }\r\n\r\n            &.scrollable {\r\n              max-height: 200px;\r\n              /* Limit height for scrolling */\r\n              // overflow-y: auto;\r\n              padding-right: 4px;\r\n\r\n              /* Custom scrollbar */\r\n              &::-webkit-scrollbar {\r\n                width: 4px;\r\n              }\r\n\r\n              &::-webkit-scrollbar-track {\r\n                background: #f1f5f9;\r\n                border-radius: 2px;\r\n              }\r\n\r\n              &::-webkit-scrollbar-thumb {\r\n                background: #cbd5e1;\r\n                border-radius: 2px;\r\n\r\n                &:hover {\r\n                  background: #94a3b8;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .tooltip-item {\r\n            padding: 10px 12px;\r\n            border-radius: 8px;\r\n            background: #eef2ff;\r\n            border: 1px solid #e2e8f0;\r\n            transition: all 0.2s ease;\r\n\r\n            &.clickable {\r\n              cursor: pointer;\r\n\r\n              &:hover {\r\n                background: #d8e3f7;\r\n                border-color: #cbd5e1;\r\n                transform: translateY(-1px);\r\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n              }\r\n              &.task-item {\r\n                background: #f0fdf4;\r\n                border-color: #bbf7d0; \r\n\r\n                &:hover {\r\n                  background: #d1fae5; \r\n                  //border-color: #10b981; \r\n                  transform: translateY(-1px);\r\n                  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15); \r\n                }\r\n              }\r\n            }\r\n\r\n            .item-header {\r\n              display: flex;\r\n              justify-content: space-between;\r\n              align-items: center;\r\n              margin-bottom: 6px;\r\n\r\n              .court-ref,\r\n              .task-name {\r\n                font-size: 0.75rem;\r\n                font-weight: 600;\r\n                color: #374151;\r\n                flex: 1;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n                margin-right: 8px;\r\n              }\r\n\r\n              .item-badge {\r\n                font-size: 0.625rem;\r\n                padding: 2px 6px;\r\n                border-radius: 4px;\r\n                font-weight: 600;\r\n                text-transform: uppercase;\r\n                background: #dbeafe;\r\n                color: #1e40af;\r\n                white-space: nowrap;\r\n\r\n                &.task-badge {\r\n                  background: #fef3c7;\r\n                  color: #92400e;\r\n                }\r\n              }\r\n            }\r\n\r\n            .item-details {\r\n              font-size: 0.6875rem;\r\n              color: #6b7280;\r\n              line-height: 1.4;\r\n              font-weight: 400;\r\n              display: -webkit-box;\r\n              -webkit-line-clamp: 2;\r\n              line-clamp: 2;\r\n              -webkit-box-orient: vertical;\r\n              overflow: hidden;\r\n            }\r\n          }\r\n\r\n          .tooltip-more {\r\n            font-size: 0.75rem;\r\n            color: #6b7280;\r\n            font-weight: 500;\r\n            padding: 8px 12px;\r\n            background: #f1f5f9;\r\n            border-radius: 6px;\r\n            text-align: center;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            gap: 4px;\r\n            margin-top: 4px;\r\n\r\n            .more-icon {\r\n              font-weight: 700;\r\n              color: #3b82f6;\r\n            }\r\n          }\r\n        }\r\n\r\n        .see-more-btn {\r\n          padding: 12px 16px;\r\n          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\r\n          color: #fff;\r\n          border: none;\r\n          border-radius: 0 0 12px 12px;\r\n          font-size: 0.75rem;\r\n          cursor: pointer;\r\n          font-weight: 600;\r\n          transition: all 0.2s ease;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          gap: 6px;\r\n          border-top: 1px solid #e2e8f0;\r\n\r\n          // .btn-icon {\r\n          //   font-size: 0.875rem;\r\n          // }\r\n\r\n          &:hover {\r\n            background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\r\n          }\r\n\r\n          &:active {\r\n            background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);\r\n          }\r\n        }\r\n\r\n        &::before {\r\n          content: \"\";\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n          border: 6px solid transparent;\r\n        }\r\n\r\n        /* Bottom positioning arrow */\r\n        &.tooltip-bottom-center::before,\r\n        &.tooltip-bottom-left::before,\r\n        &.tooltip-bottom-right::before {\r\n          top: -12px;\r\n          border-bottom-color: #e2e8f0;\r\n        }\r\n\r\n        &.tooltip-bottom-center::before {\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n        }\r\n\r\n        &.tooltip-bottom-left::before {\r\n          left: 20px;\r\n        }\r\n\r\n        &.tooltip-bottom-right::before {\r\n          right: 20px;\r\n        }\r\n\r\n        /* Top positioning arrow */\r\n        &.tooltip-top-center::before,\r\n        &.tooltip-top-left::before,\r\n        &.tooltip-top-right::before {\r\n          bottom: -12px;\r\n          border-top-color: #e2e8f0;\r\n        }\r\n\r\n        &.tooltip-top-center::before {\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n        }\r\n\r\n        &.tooltip-top-left::before {\r\n          left: 20px;\r\n        }\r\n\r\n        &.tooltip-top-right::before {\r\n          right: 20px;\r\n        }\r\n\r\n        /* Right positioning arrow */\r\n        &.tooltip-right-center::before,\r\n        &.tooltip-right-top::before,\r\n        &.tooltip-right-bottom::before {\r\n          left: -12px;\r\n          border-right-color: #e2e8f0;\r\n        }\r\n\r\n        &.tooltip-right-center::before {\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n        }\r\n\r\n        &.tooltip-right-top::before {\r\n          top: 20px;\r\n        }\r\n\r\n        &.tooltip-right-bottom::before {\r\n          bottom: 20px;\r\n        }\r\n\r\n        /* Left positioning arrow */\r\n        &.tooltip-left-center::before,\r\n        &.tooltip-left-top::before,\r\n        &.tooltip-left-bottom::before {\r\n          right: -12px;\r\n          border-left-color: #e2e8f0;\r\n        }\r\n\r\n        &.tooltip-left-center::before {\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n        }\r\n\r\n        &.tooltip-left-top::before {\r\n          top: 20px;\r\n        }\r\n\r\n        &.tooltip-left-bottom::before {\r\n          bottom: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Monthly Summary Section */\r\n  .monthly-summary {\r\n    margin-top: 1.5rem;\r\n    padding: 1rem;\r\n    background: var(--grey-lightest-shade);\r\n    border: 1px solid var(--grey-shade-one);\r\n    border-radius: var(--border-radius-primary);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n\r\n    .summary-header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin-bottom: 1rem;\r\n      padding-bottom: 0.75rem;\r\n      border-bottom: 1px solid var(--grey-shade-one);\r\n\r\n      h4 {\r\n        margin: 0;\r\n        font-size: 0.9rem;\r\n        font-weight: 600;\r\n        color: var(--primary-color);\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n\r\n        &::before {\r\n          content: \"\";\r\n          width: 6px;\r\n          height: 6px;\r\n          background: var(--primary-light-color);\r\n          border-radius: 50%;\r\n          box-shadow: 0 0 8px rgba(58, 134, 255, 0.4);\r\n        }\r\n      }\r\n    }\r\n    .summary-stats {\r\n      display: flex;\r\n      gap: 1rem;\r\n\r\n      .stat-item {\r\n        flex: 1;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.75rem;\r\n        padding: 0.75rem;\r\n        border-radius: var(--border-radius-primary);\r\n        transition: all 0.2s ease;\r\n        cursor: default;\r\n\r\n        &.hearings-stat {\r\n          background: var(--primary-light-bg);\r\n          border: 1px solid rgba(0, 74, 154, 0.2);\r\n\r\n          &:hover {\r\n            background: rgba(238, 242, 255, 0.8);\r\n            transform: translateY(-1px);\r\n            box-shadow: 0 4px 8px rgba(0, 74, 154, 0.1);\r\n          }\r\n\r\n          .stat-content .stat-number {\r\n            color: var(--primary-color);\r\n          }\r\n\r\n          .stat-content .stat-label {\r\n            color: var(--primary-color);\r\n          }\r\n        }\r\n\r\n        &.tasks-stat {\r\n          background: var(--success-light-bg);\r\n          border: 1px solid rgba(22, 101, 52, 0.2);\r\n\r\n          &:hover {\r\n            background: var(--success-dark-bg);\r\n            transform: translateY(-1px);\r\n            box-shadow: 0 4px 8px rgba(22, 101, 52, 0.1);\r\n          }\r\n\r\n          .stat-content .stat-number {\r\n            color: var(--success-color);\r\n          }\r\n\r\n          .stat-content .stat-label {\r\n            color: var(--success-color);\r\n          }\r\n        }\r\n\r\n        .stat-icon {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          width: 40px;\r\n          height: 40px;\r\n\r\n          .icon-image {\r\n            opacity: 0.8;\r\n          }\r\n        }\r\n\r\n        .stat-content {\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 0.25rem;\r\n\r\n          .stat-number {\r\n            font-size: 1rem;\r\n            font-weight: 700;\r\n            line-height: 1;\r\n          }\r\n\r\n          .stat-label {\r\n            font-size: 0.8rem;\r\n            font-weight: 600;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n            opacity: 0.8;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    /* Responsive adjustments for summary */\r\n    @media (max-width: 768px) {\r\n      margin-top: 1rem;\r\n      padding: 0.75rem;\r\n\r\n      .summary-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0.5rem;\r\n\r\n        .fallback-note {\r\n          font-size: 0.7rem;\r\n          padding: 0.2rem 0.4rem;\r\n        }\r\n      }\r\n\r\n      .summary-stats {\r\n        flex-direction: column;\r\n        gap: 0.75rem;\r\n\r\n        .stat-item {\r\n          padding: 0.5rem;\r\n\r\n          .stat-icon {\r\n            width: 36px;\r\n            height: 36px;\r\n          }\r\n\r\n          .stat-content .stat-number {\r\n            font-size: 1.25rem;\r\n          }\r\n\r\n          .stat-content .stat-label {\r\n            font-size: 0.7rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    @media (max-width: 480px) {\r\n      .summary-stats .stat-item {\r\n        .stat-content .stat-number {\r\n          font-size: 1.1rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Show summary only when there's enough space */\r\n  @media (max-height: 700px) {\r\n    .monthly-summary {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  /* Also hide on very small screens where calendar takes most space */\r\n  @media (max-width: 480px) and (max-height: 800px) {\r\n    .monthly-summary {\r\n      display: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
